import { useCallback } from 'react';
import { useAnnotationLibrary } from '../contexts/annotation-library.context';
import { AnnotationFloorService, AnnotationService, AnnotationOutdoorAreasService } from '../../plan/services/annotation.service';
import { AnnotationModel } from '../../plan/models/annotation.model';
import { AnnotationFilterView } from '../../plan/types/annotation.types';

export const useAnnotationsWithLibrary = () => {
  const { addAnnotations } = useAnnotationLibrary();

  const feedLibrary = useCallback((annotations: AnnotationModel[]) => {
    const libraryItems = annotations.map(annotation => ({
      id: annotation.id,
      title: annotation.title,
      content: annotation.content,
    }));
    addAnnotations(libraryItems);
  }, [addAnnotations]);

  const getFloorAnnotations = useCallback(async (
    orga: string,
    siteId: string | null,
    buildingId: string | null,
    floorId: string | null
  ): Promise<AnnotationModel[]> => {
    const annotations = await AnnotationFloorService.getAnnotations(orga, siteId, buildingId, floorId);
    feedLibrary(annotations);
    return annotations;
  }, [feedLibrary]);

  const getOutdoorAreasAnnotations = useCallback(async (
    orga: string,
    siteId: string
  ): Promise<AnnotationModel[]> => {
    const annotations = await AnnotationOutdoorAreasService.getAnnotations(orga, siteId);
    feedLibrary(annotations);
    return annotations;
  }, [feedLibrary]);

  const getAllAnnotations = useCallback(async (
    orga: string,
    annotationFilterView: AnnotationFilterView
  ): Promise<AnnotationModel[]> => {
    const annotations = await AnnotationService.getAllAnnotations(orga, annotationFilterView);
    feedLibrary(annotations);
    return annotations;
  }, [feedLibrary]);

  return {
    getFloorAnnotations,
    getOutdoorAreasAnnotations,
    getAllAnnotations,
  };
};

